import theme from "../../lib/theme";

const { layouts, scale, media, colors, corners } = theme;

export default () => ({
  hiddenAd: {
    display: 'inline',
    width: 1,
    height: 1,
    position: 'absolute',
  },
  recirculationAd: {
    padding: scale.xs,
    borderRadius: corners.l,
    width: '100%',
    [media.s.down]: {
      marginLeft: `-${scale.xs} !important`,
      marginRight: `-${scale.xs} !important`,
    },
  },
  taboolaFeedSplitAd: {
    marginTop: '0 !important',
    margin: `0 0 ${scale.s} 0`,
  }

});
